import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, ArrowDownUp, Landmark, Users, Clock, FileBarChart2,
  Tags, Upload, LogOut, Sparkles, Settings as SettingsIcon,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Panel", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/transactions", label: "Gelir / Gider", icon: ArrowDownUp, testid: "nav-transactions" },
  { to: "/bank-accounts", label: "Banka Hesapları", icon: Landmark, testid: "nav-banks" },
  { to: "/contacts", label: "Cari Hesaplar", icon: Users, testid: "nav-contacts" },
  { to: "/upcoming", label: "Yaklaşan Ödemeler", icon: Clock, testid: "nav-upcoming" },
  { to: "/reports", label: "Raporlar", icon: FileBarChart2, testid: "nav-reports" },
  { to: "/categories", label: "Kategoriler", icon: Tags, testid: "nav-categories" },
  { to: "/import", label: "Veri İçe Aktarma", icon: Upload, testid: "nav-import" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex" data-testid="app-layout">
      {/* Sidebar */}
      <aside className="w-72 shrink-0 border-r border-[#1E293B] bg-[#0B0F19]/90 backdrop-blur-xl flex flex-col" data-testid="sidebar">
        <div className="p-6 border-b border-[#1E293B]">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-emerald-500 flex items-center justify-center glow-primary">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-bold text-lg tracking-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Fintr</div>
              <div className="text-xs text-[#94A3B8]">Finansal Yönetim</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 text-sm ${
                  isActive
                    ? "bg-indigo-500/15 text-white border border-indigo-500/30 shadow-[0_0_20px_rgba(99,102,241,0.15)]"
                    : "text-[#94A3B8] hover:text-white hover:bg-[#131D31]"
                }`
              }
            >
              <item.icon className="w-4 h-4" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-[#1E293B]">
          <div className="flex items-center gap-3 px-2 py-2">
            <div className="w-9 h-9 rounded-full bg-indigo-500/20 border border-indigo-500/40 flex items-center justify-center text-sm font-semibold">
              {(user?.name || "A").charAt(0)}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{user?.name || "Yönetici"}</div>
              <div className="text-xs text-[#94A3B8] truncate">@{user?.username}</div>
            </div>
            <button
              data-testid="logout-button"
              onClick={async () => { await logout(); navigate("/login"); }}
              className="p-2 rounded-lg hover:bg-red-500/10 text-[#94A3B8] hover:text-red-400 transition-colors"
              aria-label="Çıkış yap"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0 overflow-x-hidden" data-testid="main-content">
        <div className="max-w-[1600px] mx-auto px-8 py-8">{children}</div>
      </main>
    </div>
  );
}
